import { Country } from "../Country.js";
import { EconomicSubjectVatType } from "../EconomicSubjectVatType.js";

/**
 * Country whose VAT rates apply to goods. Czech VAT payers are always taxed at Czech rates, regardless of the destination.
 */
export function getVatCountry(
	destinationCountry: Country | "outsideEu",
	vatType: EconomicSubjectVatType,
): Country | "outsideEu" {
	return vatType === EconomicSubjectVatType.CzSubject ? Country.Czechia : destinationCountry;
}
